function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.749,
    y: 398.619,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.333,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 61.445,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.454,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 12.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.717,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 36.833,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 25.43,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.889,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 74.889,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.779,
    y: 71.973,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 624.5973 321.4776)",
    style: {
      fill: "#E6E6E6"
    },
    width: 243.04,
    height: 177.533
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.034,
    y: 71.973,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 611.3596 321.4776)",
    style: {
      fill: "#F0F0F0"
    },
    width: 251.292,
    height: 177.533
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.956,
    y: 50.135,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 466.4187 -144.9411)",
    style: {
      fill: "#FAFAFA"
    },
    width: 147.448,
    height: 221.207
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "362.512,234.463 312.154,87.015 264.064,87.015 314.423,234.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "304.092,234.463 253.734,87.015 234.986,87.015 285.345,234.463  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.308,
    y: 159.784,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 356.7703 -35.2927)",
    style: {
      fill: "#E6E6E6"
    },
    width: 147.448,
    height: 1.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.576,
    y: 79.544,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 214.9712 280.7584)",
    style: {
      fill: "#E0E0E0"
    },
    width: 85.819,
    height: 121.671
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.498,
    y: 79.544,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 205.458 280.7584)",
    style: {
      fill: "#F5F5F5"
    },
    width: 88.462,
    height: 121.671
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.482,
    y: 104.88,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 243.1083 37.6501)",
    style: {
      fill: "#FFFFFF"
    },
    width: 102.494,
    height: 70.998
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M97.93,286.396c6.371-15.718,21.522-21.57,26.756-31.494c6.858-13.003,6.819-32.508,0.98-39.547 c-5.073-6.116-21.874,35.242-23.766,39.863c-6.509,15.893-8.401,27.687-9.621,39.114c0.139-9.713,0.272-18.631,0.381-25.512 c0.356-22.443,0.801-29.662,1.004-31.883c0.701-1.085,1.53-2.349,2.011-3.027c4.066-5.732,13.087-12.556,17.595-20.889 c6.583-12.167,5.519-26.729,0.902-32.151c-4.828-5.669-13.362,7.73-17.894,21.007c-4.531,13.277-2.595,25.985-3.866,37.011 c-0.266,2.163-0.539,10.377-0.795,21.771c-1.375-12.26-4.113-20.473-9.187-28.127c-6.241-9.414-11.629-20.877-16.772-19.395 c-5.142,1.482-2.374,16.649,1.694,27.298c3.623,9.483,21.497,18.941,24.13,26.566c-0.31,15.444-0.587,35.011-0.784,53.228 c-1.409-9.41-0.44-10.2-6.214-24.606c-3.433-8.565-17.506-19.127-19.184-13.242c-1.647,5.775,0.873,17.007,6.186,24.796 c4.286,6.284,13.795,6.277,15.995,10.176c0.513,0.91,2.211,4.397,3.18,6.402c-0.23,22.241-0.332,41.873-0.219,48.567l0.922,0.067 c-0.044-1.728,0.067-13.042,0.248-28.014c2.309-7.967,17.854-12.617,22.656-20.902c5.026-8.67,8.637-18.788,6.482-25.563 c-1.797-5.648-15.963,2.033-21.712,11.393c-3.829,6.234-6.168,12.888-7.26,21.827c0.131-10.199,0.28-21.157,0.425-31.499 C93.367,297.052,96.021,291.107,97.93,286.396z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M107.059,382.398H74.384c-1.785,0-3.324-1.258-3.678-3.007l-2.32-11.436h44.672l-2.32,11.436 C110.383,381.141,108.845,382.398,107.059,382.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M113.992,372.389H67.451c-1.115,0-2.053-0.838-2.177-1.946l-0.952-8.454 c-0.146-1.299,0.87-2.436,2.177-2.436h48.444c1.307,0,2.324,1.137,2.177,2.436l-0.952,8.454 C116.044,371.551,115.107,372.389,113.992,372.389z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.637,
    y: 267.616,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 821.2639 642.7251)",
    style: {
      fill: "#F0F0F0"
    },
    width: 9.989,
    height: 107.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.062,
    y: 375.109,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 613.8525 757.3814)",
    style: {
      fill: "#F0F0F0"
    },
    width: 209.729,
    height: 7.164
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.226,
    y: 267.616,
    style: {
      fill: "#F5F5F5"
    },
    width: 207.411,
    height: 107.492
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.988,
    y: 260.841,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 826.2983 528.4578)",
    style: {
      fill: "#E0E0E0"
    },
    width: 10.323,
    height: 6.775
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.542,
    y: 260.841,
    style: {
      fill: "#EBEBEB"
    },
    width: 212.446,
    height: 6.775
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M390.751,314.041h-177.64c-4.428,0-8.03-3.602-8.03-8.031v-23.02c0-4.429,3.603-8.031,8.03-8.031 h177.64c4.429,0,8.031,3.602,8.031,8.031v23.02C398.782,310.439,395.18,314.041,390.751,314.041z M213.111,276.959 c-3.325,0-6.03,2.706-6.03,6.031v23.02c0,3.325,2.705,6.031,6.03,6.031h177.64c3.325,0,6.031-2.706,6.031-6.031v-23.02 c0-3.325-2.706-6.031-6.031-6.031H213.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M390.751,362.191h-177.64c-4.428,0-8.03-3.603-8.03-8.031v-23.02c0-4.429,3.603-8.031,8.03-8.031 h177.64c4.429,0,8.031,3.603,8.031,8.031v23.02C398.782,358.589,395.18,362.191,390.751,362.191z M213.111,325.109 c-3.325,0-6.03,2.706-6.03,6.031v23.02c0,3.325,2.705,6.031,6.03,6.031h177.64c3.325,0,6.031-2.706,6.031-6.031v-23.02 c0-3.325-2.706-6.031-6.031-6.031H213.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.382,298.042h-96.9c-1.432,0-2.597-1.165-2.597-2.597v-1.892c0-1.432,1.165-2.597,2.597-2.597 h96.9c1.432,0,2.597,1.165,2.597,2.597v1.892C352.979,296.877,351.814,298.042,350.382,298.042z M253.482,292.957 c-0.323,0-0.597,0.273-0.597,0.597v1.892c0,0.323,0.273,0.597,0.597,0.597h96.9c0.323,0,0.597-0.273,0.597-0.597v-1.892 c0-0.323-0.273-0.597-0.597-0.597H253.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M350.382,346.192h-96.9c-1.432,0-2.597-1.165-2.597-2.597v-1.892c0-1.432,1.165-2.597,2.597-2.597 h96.9c1.432,0,2.597,1.165,2.597,2.597v1.892C352.979,345.027,351.814,346.192,350.382,346.192z M253.482,341.107 c-0.323,0-0.597,0.273-0.597,0.597v1.892c0,0.323,0.273,0.597,0.597,0.597h96.9c0.323,0,0.597-0.273,0.597-0.597v-1.892 c0-0.323-0.273-0.597-0.597-0.597H253.482z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M282.221,153.489c-43.131-34.179-68.695-73.331-121.582-87.808 c-44.236-12.109-66.359,6.751-77.956,41.196C54.1,191.775,132.683,285.374,227.955,325.093 c90.255,37.626,161.96,7.26,182.625-67.029c7.806-28.063,7.096-76.95-39.096-90.721 C337.601,157.241,318.965,182.606,282.221,153.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M282.221,153.489c-43.131-34.179-68.695-73.331-121.582-87.808 c-44.236-12.109-66.359,6.751-77.956,41.196C54.1,191.775,132.683,285.374,227.955,325.093 c90.255,37.626,161.96,7.26,182.625-67.029c7.806-28.063,7.096-76.95-39.096-90.721 C337.601,157.241,318.965,182.606,282.221,153.489z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__343_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 245,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Smartphone"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 372.131,
    y: 170.219,
    transform: "matrix(0.0645 -0.9979 0.9979 0.0645 180.5282 534.0103)",
    style: {
      fill: "#407BFF"
    },
    width: 5.902,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.497,
    y: 153.054,
    transform: "matrix(0.0644 -0.9979 0.9979 0.0644 198.7362 519.0799)",
    style: {
      fill: "#407BFF"
    },
    width: 19.393,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M364.44,115.736H246.886c-6.158,0-11.522,5.038-11.921,11.196l-15.182,234.499 c-0.399,6.158,4.313,11.196,10.471,11.196h117.554c6.158,0,11.522-5.038,11.921-11.196l15.182-234.499 C375.31,120.774,370.598,115.736,364.44,115.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M360.708,115.736H246.886c-6.158,0-11.522,5.038-11.921,11.196l-15.182,234.499 c-0.399,6.158,4.313,11.196,10.471,11.196h113.823c6.158,0,11.522-5.038,11.921-11.196l15.182-234.499 C371.578,120.774,366.866,115.736,360.708,115.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M351.112,355.3H225.906c-1.978,0-3.544-1.671-3.416-3.644l13.738-212.192 c0.117-1.801,1.611-3.202,3.416-3.202H364.85c1.978,0,3.544,1.671,3.416,3.644l-13.738,212.192 C354.411,353.899,352.917,355.3,351.112,355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.288,129.316H277.78c-1.002,0-1.762-0.812-1.697-1.814l0,0 c0.065-1.002,0.93-1.814,1.932-1.814h45.508c1.002,0,1.762,0.812,1.697,1.814l0,0 C325.155,128.504,324.29,129.316,323.288,129.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.768,364.215c-0.127,2.462-2.226,4.457-4.688,4.457c-2.462,0-4.354-1.996-4.227-4.457 c0.127-2.462,2.226-4.458,4.688-4.458C286.003,359.757,287.896,361.753,287.768,364.215z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M337.471,195.036H230.556l-6.792,104.907h113.707c6.158,0,11.196-5.038,11.196-11.196 v-82.516C348.667,200.074,343.629,195.036,337.471,195.036z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M327.513,290.614H196.483c-6.158,0-11.196-5.038-11.196-11.196v-82.516 c0-6.158,5.038-11.196,11.196-11.196h131.031c6.158,0,11.196,5.038,11.196,11.196v82.516 C338.709,285.576,333.671,290.614,327.513,290.614z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M181.713,184.503c-0.256,0-0.512-0.098-0.707-0.293l-1.793-1.793 c-0.391-0.391-0.391-1.023,0-1.414c0.391-0.391,1.023-0.391,1.414,0l1.793,1.793c0.391,0.391,0.391,1.023,0,1.414 C182.225,184.406,181.969,184.503,181.713,184.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M179.011,190.778h-2.535c-0.553,0-1-0.448-1-1c0-0.552,0.447-1,1-1h2.535c0.553,0,1,0.448,1,1 C180.011,190.33,179.564,190.778,179.011,190.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M188.077,181.798c-0.52,0-0.959-0.402-0.996-0.929l-0.181-2.529 c-0.04-0.551,0.375-1.029,0.926-1.069c0.562-0.041,1.029,0.376,1.068,0.926l0.181,2.529c0.04,0.551-0.375,1.029-0.926,1.069 C188.125,181.797,188.101,181.798,188.077,181.798z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "273.194,279.833 313.415,320.054 313.415,279.833  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.218,262.209l-1.948-8.493c-0.511-2.228-0.517-4.542-0.017-6.772l2.71-12.098 c2.416-10.786-3.058-21.562-12.543-26.304c0.081-0.225,0.173-0.444,0.227-0.683c0.691-3.085-1.25-6.146-4.334-6.837 c-3.085-0.691-6.146,1.249-6.837,4.334c-0.054,0.239-0.063,0.477-0.086,0.715c-10.602,0.242-20.151,7.652-22.567,18.438 l-2.71,12.098c-0.5,2.23-1.493,4.321-2.905,6.118l-5.386,6.85c-2.296,2.921-0.759,7.239,2.867,8.051l47.501,10.642 C281.816,269.08,285.049,265.831,284.218,262.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M248.345,264.832c-1.563-0.35-2.967,1.006-2.698,2.585c0.542,3.188,2.952,5.888,6.303,6.639 c3.351,0.751,6.682-0.663,8.533-3.315c0.917-1.313,0.226-3.139-1.337-3.489L248.345,264.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.867,247.981c-0.484,0-0.959-0.234-1.248-0.667c-4.759-7.127-6.457-15.679-4.782-24.082 c1.675-8.403,6.522-15.651,13.648-20.409c0.689-0.46,1.619-0.274,2.08,0.415c0.46,0.689,0.274,1.621-0.414,2.081 c-6.46,4.313-10.854,10.883-12.372,18.5c-1.518,7.617,0.021,15.37,4.334,21.83c0.46,0.689,0.274,1.62-0.414,2.08 C212.443,247.899,212.153,247.981,211.867,247.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M218.225,243.736c-0.484,0-0.959-0.234-1.248-0.667c-3.624-5.428-4.918-11.942-3.642-18.343 c1.275-6.4,4.968-11.921,10.395-15.545c0.688-0.461,1.62-0.275,2.08,0.415c0.46,0.689,0.274,1.621-0.414,2.081 c-4.762,3.179-8,8.022-9.12,13.636c-1.119,5.615,0.016,11.329,3.194,16.091c0.46,0.689,0.274,1.62-0.414,2.08 C218.801,243.654,218.511,243.736,218.225,243.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M224.583,239.492c-0.484,0-0.959-0.234-1.248-0.667c-2.491-3.729-3.38-8.206-2.503-12.604 c0.876-4.398,3.413-8.191,7.143-10.682c0.688-0.461,1.619-0.275,2.08,0.415c0.46,0.689,0.274,1.621-0.414,2.081 c-3.064,2.045-5.146,5.161-5.866,8.773c-0.721,3.612,0.01,7.289,2.055,10.352c0.46,0.689,0.274,1.62-0.414,2.08 C225.159,239.41,224.87,239.492,224.583,239.492z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.348,269.093c-0.543,0-1.067-0.296-1.334-0.811c-0.38-0.736-0.091-1.642,0.645-2.022 c6.902-3.563,12.003-9.601,14.364-17c2.36-7.4,1.697-15.276-1.866-22.178c-0.38-0.736-0.091-1.641,0.645-2.021 c0.736-0.378,1.641-0.092,2.021,0.645c3.931,7.613,4.662,16.302,2.058,24.465c-2.604,8.164-8.232,14.824-15.845,18.755 C298.815,269.039,298.579,269.093,298.348,269.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.841,262.301c-0.543,0-1.067-0.296-1.334-0.812c-0.38-0.736-0.091-1.642,0.645-2.021 c5.088-2.627,8.848-7.077,10.588-12.531c1.739-5.455,1.251-11.261-1.376-16.348c-0.38-0.736-0.091-1.641,0.645-2.021 c0.736-0.378,1.641-0.092,2.021,0.645c2.994,5.799,3.551,12.417,1.567,18.635c-1.983,6.218-6.27,11.291-12.068,14.286 C295.308,262.247,295.073,262.301,294.841,262.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M291.334,255.508c-0.543,0-1.067-0.296-1.334-0.811c-0.38-0.736-0.091-1.642,0.645-2.021 c3.273-1.689,5.692-4.553,6.811-8.062c1.119-3.51,0.806-7.244-0.885-10.517c-0.38-0.736-0.091-1.642,0.645-2.021 c0.737-0.378,1.641-0.092,2.021,0.645c4.247,8.226,1.01,18.373-7.216,22.621C291.801,255.454,291.566,255.508,291.334,255.508z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M203.359,125.847h-7.64c-0.4,0-0.762,0.327-0.804,0.728l-1.602,15.24 c-0.042,0.4,0.251,0.728,0.651,0.728h7.64c0.4,0,0.762-0.327,0.804-0.728l1.602-15.24 C204.052,126.175,203.759,125.847,203.359,125.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M202.672,125.847h-6.953c-0.4,0-0.762,0.327-0.804,0.728l-1.602,15.24 c-0.042,0.4,0.251,0.728,0.651,0.728h6.953c0.4,0,0.762-0.327,0.804-0.728l1.602-15.24 C203.365,126.175,203.072,125.847,202.672,125.847z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M165.07,407.647c1.039,0,2.037-0.143,2.353-0.61c0.111-0.163,0.191-0.442-0.053-0.838 c-0.136-0.223-0.348-0.374-0.627-0.449c-1.364-0.366-4.123,1.246-4.24,1.315c-0.067,0.04-0.101,0.118-0.085,0.197 c0.016,0.079,0.08,0.142,0.159,0.157C163.097,407.523,164.101,407.647,165.07,407.647z M166.285,406.077 c0.135,0,0.261,0.014,0.373,0.044c0.179,0.048,0.306,0.136,0.387,0.268c0.146,0.238,0.102,0.356,0.056,0.424 c-0.354,0.523-2.4,0.535-3.915,0.323C163.92,406.75,165.339,406.077,166.285,406.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M162.614,407.424c0.027,0,0.053-0.006,0.078-0.017c0.958-0.439,2.818-2.19,2.63-3.105 c-0.044-0.215-0.208-0.483-0.738-0.536c-0.395-0.04-0.746,0.071-1.049,0.329c-0.993,0.846-1.116,3.027-1.121,3.12 c-0.004,0.068,0.03,0.134,0.087,0.174C162.535,407.411,162.574,407.424,162.614,407.424z M164.446,404.141 c0.038,0,0.076,0.002,0.115,0.006c0.347,0.035,0.375,0.171,0.383,0.216c0.113,0.549-1.142,1.926-2.113,2.525 c0.076-0.637,0.307-1.942,0.96-2.497C163.987,404.223,164.203,404.141,164.446,404.141z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.694,
    y: 388.479,
    style: {
      fill: "#FF8B7B"
    },
    width: 8.098,
    height: 18.752
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "94.948,398.294 103.036,399.169 108.313,380.966 100.225,380.091  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M106.799,401.013c1.018,0.256,2.031,0.365,2.456-0.004c0.149-0.129,0.296-0.376,0.155-0.816 c-0.078-0.247-0.249-0.444-0.504-0.585c-1.246-0.688-4.348,0.177-4.48,0.214c-0.076,0.022-0.129,0.088-0.132,0.168 c-0.003,0.08,0.043,0.155,0.117,0.19C104.896,400.408,105.85,400.775,106.799,401.013z M108.378,399.808 c0.132,0.033,0.252,0.078,0.354,0.134c0.164,0.09,0.266,0.206,0.313,0.353c0.084,0.264,0.012,0.367-0.05,0.42 c-0.476,0.414-2.484-0.079-3.916-0.657C105.894,399.87,107.451,399.575,108.378,399.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M104.447,400.193c0.026,0.007,0.053,0.008,0.08,0.003c1.047-0.184,3.302-1.404,3.344-2.327 c0.01-0.217-0.085-0.514-0.59-0.696c-0.377-0.136-0.749-0.116-1.109,0.056c-1.182,0.566-1.842,2.626-1.869,2.713 c-0.02,0.064-0.004,0.136,0.042,0.188C104.373,400.162,104.409,400.183,104.447,400.193z M107.054,397.499 c0.037,0.009,0.075,0.021,0.112,0.034c0.331,0.119,0.325,0.256,0.322,0.301c-0.025,0.554-1.595,1.564-2.695,1.898 c0.232-0.592,0.781-1.785,1.558-2.156C106.584,397.465,106.816,397.439,107.054,397.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M103.47,398.421l-8.847-2.539c-0.322-0.092-0.655,0.048-0.802,0.339l-3.262,6.465 c-0.338,0.671,0.065,1.513,0.812,1.714c3.102,0.834,4.646,1.086,8.537,2.203c2.394,0.687,7.264,2.348,10.569,3.296 c3.233,0.928,4.534-2.155,3.253-2.835c-5.744-3.052-7.583-5.515-9.1-7.797C104.357,398.854,103.941,398.556,103.47,398.421z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M161.704,406.294h-8.843c-0.331,0-0.608,0.23-0.665,0.553l-1.285,7.198 c-0.133,0.746,0.464,1.453,1.228,1.44c3.188-0.054,7.789-0.241,11.798-0.241c4.688,0,7.252,0.256,12.75,0.256 c3.324,0,4.1-3.361,2.695-3.665c-6.395-1.386-10.078-1.534-15.7-4.91C163.072,406.558,162.403,406.294,161.704,406.294z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 153.687,
    y: 388.484,
    style: {
      opacity: 0.2
    },
    width: 8.101,
    height: 9.666
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "100.222,380.096 108.313,380.972 105.382,391.069 97.498,389.478  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M148.467,202.029c0,0-4.463,61.11-8.494,84.294c-4.414,25.388-30.069,103.125-30.069,103.125 L95.2,386.765c0,0,18.528-73.004,20.581-98.141c2.228-27.281,4.909-83.517,4.909-83.517L148.467,202.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M140.936,227.405c0.809-3.367,2.647,0.864,4.784,8.196c-1.617,18.141-3.732,39.152-5.748,50.726 c-0.454,2.592-1.13,5.737-1.971,9.292C138.743,269.736,138.766,236.487,140.936,227.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M163.738,200.336c0,0,5.877,61.462,6.076,86.156c0.207,25.685-5.086,109.786-5.086,109.786H151.01 c0,0-4.116-82.6-5.829-107.826c-1.868-27.5-9.74-84.981-9.74-84.981L163.738,200.336z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M113.005,384.501c0.063,0.011-2.303,5.324-2.303,5.324l-16.543-3.018l1.004-4.943L113.005,384.501 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M167.128,390.815c0.063,0-0.525,5.695-0.525,5.695h-16.687l-0.673-5.083L167.128,390.815z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M121.119,145.56c-1.098,2.135-2.306,4.371-3.413,6.583l-3.359,6.656 c-1.088,2.226-2.153,4.452-3.184,6.678c-0.995,2.234-1.972,4.457-2.837,6.676l-0.075-3.505c0.62,1.755,1.234,3.547,2.102,5.265 c0.391,0.876,0.883,1.714,1.317,2.586c0.495,0.841,0.97,1.699,1.513,2.525c1.044,1.677,2.196,3.318,3.436,4.907 c0.623,0.792,1.244,1.594,1.904,2.361c0.645,0.748,1.377,1.546,1.961,2.195l0.201,0.223c1.064,1.185,0.967,3.008-0.218,4.072 c-0.939,0.843-2.283,0.954-3.328,0.375c-1.144-0.636-2.06-1.226-3.027-1.904c-0.947-0.667-1.882-1.352-2.78-2.085 c-1.798-1.463-3.476-3.079-5.058-4.814c-1.572-1.739-3.054-3.599-4.349-5.614c-1.34-1.984-2.457-4.149-3.463-6.377 c-0.448-0.992-0.496-2.063-0.214-3.031l0.139-0.474c0.763-2.609,1.613-5.143,2.553-7.622c0.936-2.474,1.938-4.905,2.998-7.299 c1.053-2.395,2.175-4.75,3.34-7.081c1.199-2.33,2.35-4.61,3.707-6.939c1.613-2.768,5.164-3.703,7.931-2.091 c2.675,1.559,3.639,4.928,2.244,7.65L121.119,145.56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M126.863,142.019c0.398,7.626-8.263,21.64-8.263,21.64l-17.832-8.91c0,0,3.042-9.665,9.877-17.227 C120.085,127.081,126.494,134.956,126.863,142.019z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M114.777,191.735l3.59,6.002l7.47-4.78c0,0-1.985-3.817-5.807-5.227 c-1.136-0.419-2.424,0.121-3.038,1.268L114.777,191.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M121.363,200.291l3.471-0.65c1.229-0.23,2.035-1.418,1.795-2.645l-0.792-4.039l-7.47,4.78 l0.506,1.209C119.282,199.926,120.32,200.486,121.363,200.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M142.425,103.66c0.078,0.655,0.484,1.158,0.906,1.125c0.422-0.034,0.701-0.591,0.622-1.246 c-0.078-0.655-0.484-1.158-0.906-1.125C142.626,102.447,142.347,103.005,142.425,103.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5652"
    },
    d: "M142.85,104.823c0,0,1.919,3.66,3.753,5.354c-1.013,1.171-3.014,0.831-3.014,0.831L142.85,104.823z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.627,100.212c0.103,0.013,0.208-0.016,0.289-0.088c1.239-1.1,2.58-0.73,2.636-0.715 c0.206,0.058,0.411-0.058,0.462-0.261c0.051-0.204-0.072-0.417-0.276-0.478c-0.07-0.022-1.787-0.512-3.339,0.866 c-0.156,0.137-0.165,0.381-0.022,0.543C139.445,100.155,139.535,100.201,139.627,100.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M122.271,110.902c1.912,5.784,4.451,16.463,0.825,20.735c0,0,2.38,5.83,13.349,4.906 c12.061-1.016,4.998-6.451,4.998-6.451c-6.784-1.012-7.239-5.892-6.679-10.558L122.271,110.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M120.513,133.753c-1.137-1.81-2.396-3.883-0.255-4.654c2.356-0.848,15.549-2.229,20.248-1.073 c4.699,1.156,3.747,4.982,3.747,4.982L120.513,133.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M159.16,136.19c1.721,1.582,3.581,3.326,5.429,4.931c1.848,1.639,3.724,3.24,5.602,4.821 c1.894,1.555,3.802,3.07,5.728,4.519c1.942,1.408,3.887,2.766,5.854,3.956l-4.012-0.374c1.483-0.374,3.083-1.089,4.646-2.154 c1.558-1.063,3.117-2.376,4.57-3.88c1.478-1.482,2.869-3.143,4.212-4.872c0.667-0.868,1.339-1.748,1.969-2.657 c0.619-0.893,1.264-1.869,1.816-2.705l0.109-0.165c0.878-1.332,2.67-1.699,4.002-0.821c1.083,0.714,1.526,2.035,1.183,3.218 c-0.378,1.299-0.774,2.409-1.24,3.577c-0.458,1.151-0.935,2.298-1.479,3.419c-1.088,2.243-2.34,4.434-3.827,6.545 c-1.499,2.095-3.204,4.144-5.303,5.971c-2.085,1.824-4.58,3.477-7.543,4.521c-1.255,0.442-2.571,0.329-3.68-0.211l-0.332-0.163 c-2.537-1.247-4.929-2.616-7.217-4.087c-2.279-1.47-4.47-3.023-6.595-4.637c-2.123-1.612-4.173-3.297-6.173-5.032 c-1.996-1.774-3.92-3.479-5.868-5.466c-2.241-2.288-2.204-5.96,0.084-8.201c2.211-2.166,5.715-2.204,7.971-0.138L159.16,136.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M153.055,131.007c0,0,10.075,9.783,11.241,70.278c-16.111,3.903-31.627,5.344-43.605,3.822 c-0.575-7.589-1.419-33.925-9.122-61.699c-1.373-4.951,1.743-10.014,6.788-10.988c1.532-0.296,3.141-0.569,4.74-0.782 c5.481-0.729,13.442-1.577,18.346-1.544C147.908,130.136,153.055,131.007,153.055,131.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M145.228,141.54c0.967,7.575,13.953,22.119,13.953,22.119l15.433-15.995 c0,0-6.674-7.18-14.827-13.298C148.528,125.92,144.332,134.524,145.228,141.54z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M199.324,142.659l5.157-4.724l-6.186-6.355c0,0-3.34,2.713-3.952,6.74 c-0.182,1.197,0.607,2.35,1.854,2.721L199.324,142.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M206.38,134.486l-1.335-3.269c-0.473-1.158-1.798-1.708-2.952-1.226l-3.797,1.588l6.186,6.355 l1.083-0.738C206.441,136.598,206.781,135.468,206.38,134.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M120.728,103.979c1.448,8.001,1.896,12.741,6.393,16.55c6.765,5.73,16.111,1.272,17.043-6.903 c0.839-7.358-1.67-19.207-9.813-21.791C126.329,89.289,119.28,95.978,120.728,103.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M136.504,106.877c2.811,0.647,5.027-2.602,5.291-3.528c-1.367,0.132-3.792-0.573-4.277-1.191 c1.499,0.132,2.954-1.72,3.131-2.425c-1.632-0.22-3.439-1.632-3.924-2.558c2.425-0.044,5.351-4.321,2.675-8.158 c-2.675-3.836-13.831-0.617-15.419-3.351c-2.337,1.367-0.265,3.175-0.265,3.175s-15.786,2.954-8.51,9.084 c-5.335,0.485-6.085,6.798-1.632,10.013c4.454,3.215,4.674,5.332,2.91,5.067c0.705,1.367,3.875,1.543,4.054,0.221 c0.752,2.778,2.913,6.526,7.896,5.909C133.417,118.518,138.311,111.551,136.504,106.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M116.611,97.003c-3.757,0.517-5.473-1.605-4.528-3.472 C107.425,95.909,112.511,101.173,116.611,97.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M132.607,105.664c0.643,1.744,1.967,3.233,3.281,4.112c1.976,1.322,3.814,0.014,3.469-2.033 c-0.311-1.842-1.713-4.75-3.795-5.269C133.511,101.963,131.872,103.67,132.607,105.664z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M386.785,387.517c-7.401-17.461-10.391-37.974-1.92-37.149c8.69,0.846,7.666,31.804,9.08,35.204 C391.228,387.901,386.785,387.517,386.785,387.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M389.181,354.391c-1.826,6.655-3.747,16.949-5.225,25.669c0.84,2.498,1.789,5.009,2.822,7.459 c0,0,4.445,0.384,7.171-1.946C392.833,382.895,393.229,363.051,389.181,354.391z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M389.216,384.32c-2.312-37.103,4.031-71.489,20.644-69.936c14.281,1.335-6.54,63.797-6.139,71.004 C397.181,387.924,389.216,384.32,389.216,384.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M400.016,384.077c2.618-26.665,16.68-57.783,22.725-47.387 c7.673,13.196-11.984,44.639-12.527,49.813C405.269,387.556,400.016,384.077,400.016,384.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M397.367,324.286c-1.684-0.276-2.624-1.33-2.518-2.818c0.121-1.676,1.5-3.345,2.784-3.37 c0.611,0.005,1.655,0.317,1.913,2.637l-0.994,0.111c-0.122-1.097-0.454-1.748-0.891-1.748c-0.003,0-0.006,0-0.009,0 c-0.683,0.013-1.72,1.246-1.806,2.441c-0.07,0.974,0.496,1.565,1.682,1.761L397.367,324.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M415.331,331.013c-0.505,0-1.171-0.196-2.044-0.769l0.547-0.836 c0.93,0.606,1.647,0.766,1.921,0.419c0.425-0.534,0.135-2.119-0.732-2.946c-0.707-0.675-1.523-0.616-2.43,0.175l-0.656-0.754 c1.284-1.12,2.698-1.174,3.776-0.145c1.215,1.16,1.623,3.286,0.824,4.292C416.331,330.711,415.956,331.013,415.331,331.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M390.815,346.103c-1.351,0-2.309-0.705-2.615-1.963c-0.398-1.632,0.403-3.642,1.618-4.059 c0.571-0.194,1.671-0.206,2.628,1.925l-0.912,0.41c-0.454-1.013-0.97-1.531-1.392-1.39c-0.646,0.222-1.255,1.713-0.971,2.878 c0.23,0.947,0.953,1.335,2.139,1.161l0.148,0.988C391.235,346.086,391.021,346.103,390.815,346.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M380.174,366.814c-1.025,0-1.843-0.519-2.292-1.497c-0.7-1.527-0.293-3.654,0.82-4.294 c0.525-0.3,1.603-0.519,2.945,1.393l-0.818,0.574c-0.638-0.908-1.248-1.319-1.629-1.1c-0.592,0.34-0.908,1.919-0.409,3.009 c0.408,0.889,1.189,1.133,2.321,0.735l0.332,0.943C380.996,366.735,380.569,366.814,380.174,366.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.888,336.621c-0.101,0-0.202-0.03-0.291-0.093c-1.374-0.982-1.868-2.34-1.32-3.631 c0.578-1.362,2.147-2.268,3.495-2.021c0.617,0.113,2.063,0.664,2.164,3.326c0.01,0.275-0.205,0.508-0.481,0.519 c-0.269,0.008-0.508-0.206-0.519-0.481c-0.052-1.385-0.529-2.23-1.345-2.38c-0.883-0.161-2.002,0.505-2.395,1.429 c-0.361,0.854-0.013,1.715,0.982,2.426c0.225,0.161,0.276,0.474,0.116,0.698C398.197,336.549,398.043,336.621,397.888,336.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409.744,363.611c-0.231,0-0.439-0.162-0.488-0.398c-0.057-0.27,0.117-0.535,0.388-0.591 c1.357-0.282,2.11-0.895,2.122-1.723c0.014-0.898-0.831-1.89-1.808-2.122c-0.897-0.215-1.693,0.272-2.229,1.372 c-0.12,0.25-0.422,0.35-0.668,0.23c-0.248-0.121-0.352-0.42-0.23-0.668c0.74-1.52,1.99-2.234,3.36-1.907 c1.44,0.343,2.595,1.737,2.575,3.109c-0.009,0.627-0.311,2.145-2.919,2.686C409.813,363.608,409.778,363.611,409.744,363.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M423.799,355.185c-0.574,0-1.345-0.344-2.213-1.637l0.83-0.557 c0.619,0.922,1.215,1.338,1.606,1.134c0.599-0.328,0.948-1.9,0.472-3.001c-0.388-0.896-1.165-1.157-2.305-0.783l-0.313-0.949 c1.618-0.534,2.941-0.034,3.534,1.335c0.669,1.542,0.218,3.659-0.909,4.275C424.325,355.099,424.087,355.185,423.799,355.185z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M420.821,393.874c0-5.558-2.035-10.635-5.392-14.54c0.695-0.117,1.238-0.698,1.238-1.424 c0-0.81-0.662-1.472-1.472-1.472h-33.481c-0.81,0-1.472,0.663-1.472,1.472c0,0.729,0.547,1.312,1.245,1.426 c-3.364,3.904-5.399,8.981-5.399,14.538c0,8.577,4.836,16.026,11.927,19.778c-0.518,0.273-0.878,0.811-0.878,1.435 c0,0.895,0.732,1.627,1.627,1.627h19.383c0.895,0,1.627-0.732,1.627-1.627c0-0.623-0.359-1.161-0.876-1.434 C415.989,409.902,420.821,402.452,420.821,393.874z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImage);
export default __webpack_public_path__ + "static/media/main_image.57fb5392fc155ab92cd3e8a4b65a8c8f.svg";
export { ForwardRef as ReactComponent };